import { FaAws, FaDocker, FaPython, FaGithub } from "react-icons/fa";
import { SiKubernetes, SiGo, SiTypescript, SiPostgresql, SiRedis, SiElasticsearch } from "react-icons/si";

const partners = [
  { name: 'Cashwise', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1688701883/Cashwise-favicon.png' },
  { name: 'Orbit', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1775642236/orbit_logo.svg' },
  { name: 'AWS', icon: FaAws },
  { name: 'Kubernetes', icon: SiKubernetes },
  { name: 'Docker', icon: FaDocker },
  { name: 'Infobip', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/infobip.png' },
  { name: 'Wema Bank', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1684875956/banks/000017.png' },
  { name: 'Flutterwave', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1776756752/Flutterwave_Logo.png' },
  { name: 'Go', icon: SiGo },
  { name: 'Providus Bank', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1684875960/banks/000023.png' },
  { name: 'TypeScript', icon: SiTypescript },
  { name: 'Squad', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/squad.png' },
  { name: 'Python', icon: FaPython },
  { name: 'NIBSS', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1776756511/NIBSS-logo.png' },
  { name: 'PostgreSQL', icon: SiPostgresql },
  { name: 'Globus Bank', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1735095980/banks/000027.jpg' },
  { name: 'Redis', icon: SiRedis },
  { name: 'Elasticsearch', icon: SiElasticsearch },
  { name: 'Checkbook', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/checkbook.png' },
  { name: 'CreditSwitch', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/creditswitch.png' },
  { name: 'Africa\'s Talking', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/africastalking.png' },
  { name: 'GitHub', icon: FaGithub },
  { name: 'Reloadly', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/reloadly.png' },
  { name: 'Dojah', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001669/dojah.png' },
  { name: 'Prembly', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1741001670/prembly.png' },
  { name: 'VISA', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1742500576/visa_logo.png' },
  { name: 'MasterCard', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1759496037/mastercard_logo.png' },
  { name: 'Chase Bank', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1747214516/Chase-Bank-Logo.png' },
  { name: 'Embedly', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1753953992/embedly.png' },
  { name: 'AfriGo', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1759496666/afrigo_logo.png' },
  { name: 'Verve', logoUrl: 'https://res.cloudinary.com/dsbqg959i/image/upload/v1759496662/verve_logo.png' }
];

const TrustedPartnersSection = () => {
  return (
    <section className='py-12 border-y border-border/20 bg-background/50 backdrop-blur-sm relative z-10 overflow-hidden'>
      <div className='max-w-[100vw] mx-auto relative'>
        <p className='text-center text-sm font-semibold text-primary/70 uppercase tracking-widest mb-10 px-4'>
          Technology Stacks & Partners I've Worked With
        </p>

        {/* Masking gradients for smooth fading edges */}
        <div className="pointer-events-none absolute inset-y-0 mt-16 left-0 w-1/6 md:w-1/4 bg-gradient-to-r from-background to-transparent z-20"></div>
        <div className="pointer-events-none absolute inset-y-0 mt-16 right-0 w-1/6 md:w-1/4 bg-gradient-to-l from-background to-transparent z-20"></div>

        <div className='flex flex-col gap-6 md:gap-8 pt-4 pb-8'>
          {[
            { items: partners.slice(0, Math.ceil(partners.length / 3)), reverse: false },
            { items: partners.slice(Math.ceil(partners.length / 3), Math.ceil(partners.length * 2 / 3)), reverse: true },
            { items: partners.slice(Math.ceil(partners.length * 2 / 3)), reverse: false }
          ].map((row, rowIndex) => (
            <div
              key={rowIndex}
              className='flex animate-marquee py-2'
              style={row.reverse ? { animationDirection: 'reverse' } : {}}
            >
              {[...row.items, ...row.items, ...row.items, ...row.items].map((partner, index) => {
                const IconComponent = partner.icon;
                return (
                  <div
                    key={`${partner.name}-${index}`}
                    className='group flex flex-col items-center justify-center transition-all duration-300 opacity-60 hover:opacity-100 grayscale hover:grayscale-0 cursor-default mx-6 md:mx-10 min-w-[70px]'
                  >
                    {IconComponent ? (
                      <IconComponent className='w-10 h-10 md:w-12 md:h-12 mb-3 text-foreground transition-transform duration-300 group-hover:-translate-y-2 group-hover:text-primary drop-shadow-md' />
                    ) : partner.logoUrl ? (
                      <div className='w-10 h-10 md:w-12 md:h-12 mb-3 flex items-center justify-center bg-white/90 rounded-xl p-1.5 transition-transform duration-300 group-hover:-translate-y-2 shadow-[0_4px_10px_rgba(0,0,0,0.3)]'>
                        <img src={partner.logoUrl} alt={`${partner.name} logo`} className='max-w-full max-h-full object-contain' />
                      </div>
                    ) : null}
                    <span className='text-[10px] md:text-xs font-bold text-muted-foreground uppercase tracking-widest group-hover:text-primary transition-colors whitespace-nowrap'>
                      {partner.name}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedPartnersSection;
